import { render } from "./AdminFull.vue?vue&type=template&id=34214ff3&scoped=true"
import script from "./AdminFull.vue?vue&type=script&lang=js"
export * from "./AdminFull.vue?vue&type=script&lang=js"

import "./AdminFull.vue?vue&type=style&index=0&id=34214ff3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34214ff3"]])

export default __exports__